import * as React from 'react';
import Link from '@mui/material/Link';
import PlaceIcon from '@mui/icons-material/Place';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import MapLink from 'components/MapLink';

const venueMapLink = "https://maps.app.goo.gl/pi7gtyUAFsGNS5YeA";

type VenueMapLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: VenueMapLinkProps = {
  linkText: "1 Museum Of Science Driveway, Boston, MA 02114",
  underline: "hover"
};

export default function VenueMapLink(linkProps: VenueMapLinkProps = defaultProps) {
  const linkText = linkProps.linkText || defaultProps.linkText || "";
  const underline = linkProps.underline || defaultProps.underline; 
  return (
    <MapLink linkUrl={venueMapLink} underline={underline} >{linkText}</MapLink>
  );
}